import React, { FC } from 'react';
import { Col, Row, Typography, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
interface BreadcrumbItem {
    title: string;
    path?: string;
}

interface PageHeaderProps {
    crumbs: BreadcrumbItem[];
}

const PageHeader: FC<PageHeaderProps> = ({ crumbs }) => {
    const { Text } = Typography;
    const { t } = useTranslation(['clients', 'common']);
    const navigate = useNavigate();

    return (
        <Row style={{ paddingBottom: 24 }}>
            <Col span={24}>
                <Space size="middle">
                    {crumbs.map((crumb, index) => {
                        const isLast = index === crumbs.length - 1;

                        return (
                            <React.Fragment key={index}>
                                <Text
                                    onClick={() => !isLast && crumb.path && navigate(crumb.path)}
                                    style={{
                                        cursor: isLast ? 'default' : 'pointer',
                                        color: isLast ? '#000000' : '#8c8c8c',
                                        fontSize: '16px',
                                        fontWeight: 600,
                                    }}
                                >
                                    {t(crumb.title)}
                                </Text>
                                {!isLast && (
                                    <Text style={{ color: '#8c8c8c', fontSize: '16px' }}>
                                        /
                                    </Text>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Space>
            </Col>
        </Row>
    );
};

export default PageHeader;